export default __webpack_public_path__ + "static/media/feature-2.40839058.svg";